import React from 'react';
import CustomGlobe from './CustomGlobe'; // Make sure the path is correct

const Monetize = () => {
  return (
    <div className='flex flex-col-reverse md:flex-row bg-[#fafafa] overflow-hidden'>
      <div className='w-full md:w-1/2 pt-6 md:pt-0 px-4 md:px-8 md:pr-20 flex flex-col gap-5 justify-center text-center md:text-left mb-8 md:mb-0'>
        <h1 className='text-[22px] md:text-[36px] font-semibold text-[#1b1b1b]'>Stay Nationally! (Coming Soon) </h1>
        <p className='text-[13px] md:text-[17px] font-normal'>Leafwell Farm is available in New York with new locations opening in South Florida, Austin Texas, & California.</p>
        <p className='text-[13px] md:text-[17px] font-normal'>Our community allows for flexible living between the Leafwell Farm locations.</p>
        <p className='text-[13px] md:text-[17px] font-normal'>Our dedicated tenant communications discord channel helps facilitate dynamic living amongst our community. This unique feature is a core value of our portfolio.</p>
      </div>
      <div className='w-full md:w-1/2 flex justify-center items-center'>
        <div className='h-ful max-h-[300px] md:max-h-[100vh]'>
          <CustomGlobe />
        </div>
      </div>
    </div>
  );
};

export default Monetize;
